/**
 * Token de acceso al API de contenidos.
 *
 * Esta web es SOLO LECTURA y no tiene panel de administración ni login
 * propio: la gestión de contenidos (crear/editar/publicar noticias y slides)
 * vive en el CMS aparte (Web.CMS.React). Por eso el único origen posible de un
 * token es Entra ID, cuando esté configurado (ver `entraId.ts`) — sin él no
 * hay ninguna sesión que ofrecer.
 *
 * Antes había aquí una sesión local de repuesto (usuario/contraseña
 * `admin`/`admin` fijos en el código, token generado con `Math.random()` y
 * guardado en `sessionStorage`) para cuando Entra ID todavía no estaba dado de
 * alta. Se quitó al borrar el panel: nada la usa ya, y Semgrep la marcaba con
 * razón (`hardcoded-secret-in-source`, `weak-random-id-generation`,
 * `sensitive-data-in-sessionstorage`) — mejor no tener ese código en absoluto
 * que tenerlo sin usar.
 */

import { getEntraAccessToken, isEntraEnabled } from './entraId';

/**
 * Token que viaja en las llamadas al API.
 *
 * `null` si Entra ID no está configurado (`VITE_ENTRA_CLIENT_ID`/
 * `VITE_ENTRA_TENANT` vacías) o si no hay cuenta con la sesión iniciada: en
 * ese caso las llamadas de lectura siguen funcionando igual, van sin cabecera
 * `Authorization` — el backend las acepta como anónimas.
 */
export async function getAdminToken(): Promise<string | null> {
  if (!isEntraEnabled()) return null;
  return getEntraAccessToken();
}
